import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

const getSession = () => {
  const raw = sessionStorage.getItem('ddesp');
  if (!raw) return { emp: 0, uid: 0 };
  const storage = JSON.parse(base64_decode(raw));
  return { emp: storage?.[0] || 0, uid: storage?.[3] || 0 };
};

export const RestIaUsageGet = (config) => {
  const { dest } = config.params || {};
  const { emp, uid } = getSession();

  switch ((dest || '').trim()) {
    case 'getConsumo': {
      return new Promise((resolve, reject) => {
        try {
          const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))];
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            data: {
              pp: base64_encode('iaUsage'),
              ll: base64_encode('getConsumo'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              reject([400, { message: 'Falha na requisição' }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    default:
      return Promise.reject([400, { message: 'Destino inválido' }]);
  }
};
